<template>
  <div style="padding-bottom: 6em">
    <sui-segment id="footer" vertical aligned="center">
      &copy;
      <span>{{$t('copyright')}}</span><br />
      <a class="footerItem" @click.prevent="goto('/footer/contact')">{{ $t('contact') }}</a> &nbsp;|&nbsp;
      <a class="footerItem" @click.prevent="goto('/footer/imprint')">{{ $t('imprint') }}</a> &nbsp;|&nbsp;
      <a class="footerItem" @click.prevent="goto('/footer/privacy')">{{ $t('privacy') }}</a> &nbsp;|&nbsp;
      <sui-dropdown @click="changeLang" id="footerDrop" simple :options="language" text="Language" v-model="$i18n.locale" /> 
      <!-- <v-icon @click.prevent="$emit('clickHelp')" small color="white">mdi-help-circle</v-icon> -->
      <!--sui-dropdown id="footerDrop" simple :options="theme" text="Theme" v-model="curTheme"></!--sui-dropdown-->
    </sui-segment>
  </div>
</template>
<script>
  export default {
    name: 'Footer',
    data() {
      return {
        currentLanguage: 'de',
        lang: 'de',
        theme: [
          {key: 'light', value: 'light', icon:"ui icon lightbulb ",  text: "Light"},
          {key: 'dark', value: 'dark', icon:"ui icon lightbulb outline", text: "Dark"},
        ],
        language: [
          { key: 'en', value: 'en', flag: 'gb', text: 'English' },
          { key: 'de', value: 'de', flag: 'de', text: 'Deutsch' },
        ]
      }
    },
    methods: {
      goto(target) {
        this.$router.push(target);
      },
      changeLang(){
        localStorage["Language"] = this.$i18n.locale
      },
      clickHelp(){
        console.log("clickHelp")
        this.$emit("clickHelp")
      }
  }
  }
</script>
<style lang="scss" scoped>
  #footer {
    color: white;
    margin: 3em auto;
    font-size: 0.9em;
  }

  .footerItem {
    color: white;
    cursor: pointer;
  }
</style>
